export default __webpack_public_path__ + "static/media/blog_inner_9.e7c98d43.png";